import React from "react";
import TeamLogo from "./TeamLogo";

export default function StandingsTable({ standings, teamsBySlug }) {
  return (
    <div data-testid="standings-table" className="overflow-x-auto border border-white/10">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-white/55">
            <th className="text-left font-display text-xs uppercase tracking-[0.22em] py-4 px-4 border-b border-white/10">#</th>
            <th className="text-left font-display text-xs uppercase tracking-[0.22em] py-4 px-4 border-b border-white/10">Team</th>
            <th className="text-right font-display text-xs uppercase tracking-[0.22em] py-4 px-4 border-b border-white/10">P</th>
            <th className="text-right font-display text-xs uppercase tracking-[0.22em] py-4 px-4 border-b border-white/10">W</th>
            <th className="text-right font-display text-xs uppercase tracking-[0.22em] py-4 px-4 border-b border-white/10">L</th>
            <th className="text-right font-display text-xs uppercase tracking-[0.22em] py-4 px-4 border-b border-white/10 hidden sm:table-cell">GD</th>
            <th className="text-right font-display text-xs uppercase tracking-[0.22em] py-4 px-4 border-b border-white/10">PTS</th>
          </tr>
        </thead>
        <tbody>
          {standings.map((row, i) => {
            const t = teamsBySlug[row.team];
            return (
              <tr key={row.team} data-testid={`standings-row-${row.team}`} className="hover:bg-white/5 transition-colors">
                <td className="py-3 px-4 border-b border-white/5 font-mono text-xs text-white/65">{String(i + 1).padStart(2, "0")}</td>
                <td className="py-3 px-4 border-b border-white/5">
                  <div className="flex items-center gap-3">
                    <div className="hidden sm:block">
                      <TeamLogo team={t} size={36} />
                    </div>
                    <div>
                      <div className="font-display text-sm text-white tracking-tight">{t?.name}</div>
                      <div className="text-[10px] uppercase tracking-[0.22em] text-white/45">{t?.city}</div>
                    </div>
                  </div>
                </td>
                <td className="py-3 px-4 border-b border-white/5 text-right font-mono text-white/85">{row.played}</td>
                <td className="py-3 px-4 border-b border-white/5 text-right font-mono text-white/85">{row.won}</td>
                <td className="py-3 px-4 border-b border-white/5 text-right font-mono text-white/85">{row.lost}</td>
                <td className="py-3 px-4 border-b border-white/5 text-right font-mono hidden sm:table-cell">
                  <span className={row.gd >= 0 ? "text-emerald-400" : "text-pshl-red"}>
                    {row.gd >= 0 ? "+" : ""}{row.gd}
                  </span>
                </td>
                <td className="py-3 px-4 border-b border-white/5 text-right">
                  <span className="font-display text-pshl-electric font-bold tracking-wider">{row.points}</span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
